import { render, staticRenderFns } from "./BrandMeetPerson.vue?vue&type=template&id=00909318&scoped=true&"
import script from "./BrandMeetPerson.vue?vue&type=script&lang=js&"
export * from "./BrandMeetPerson.vue?vue&type=script&lang=js&"
import style0 from "./BrandMeetPerson.vue?vue&type=style&index=0&id=00909318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00909318",
  null
  
)

export default component.exports